import React, { useState } from 'react';
import { FiDownload, FiCalendar, FiUser, FiBook, FiTrash2 } from 'react-icons/fi';
import api from '../services/api';
import ConfirmDialog from './ConfirmDialog';

const NoteCard = ({ note, onDeleteSuccess }) => {
  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData) : null;
  const canDelete = user?.role === 'teacher' || user?.role === 'admin';
  
  const [deleting, setDeleting] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const getTypeLabel = (type) => {
    return type === 'pastpaper' ? 'Past Paper' : 'Note';
  };

  const handleDownload = () => {
    if (note.fileUrl) {
      const filename = note.fileUrl.split('/').pop();
      window.open(`${process.env.REACT_APP_API_URL}/api/notes/download/${filename}`, '_blank');
    }
  };

  const handleConfirmDelete = async () => {
    setShowConfirm(false);
    try {
      setDeleting(true);
      await api.delete(`/notes/${note._id}`);
      if (onDeleteSuccess) onDeleteSuccess(note._id);
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to delete note');
    } finally {
      setDeleting(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <>
      <div className="note-card">
        <div className="note-card-body">
          <div className="d-flex justify-between align-center mb-2">
            <span className={`note-type ${note.type}`}>
              {getTypeLabel(note.type)}
            </span>
            {note.department && (
              <span className="department-badge">{note.department}</span>
            )}
          </div>

          <div className="note-header">
            <h3>{note.title || 'Untitled Note'}</h3>
            <p>{note.description || 'No description provided.'}</p>
          </div>
        </div>

        <div className="note-card-footer">
          <div className="note-meta-line">
            <span className="meta-item"><FiBook /> {note.subject || 'General'}</span>
            <span className="meta-item">Sem {note.semester}</span>
            {note.uploadedBy?.name && (
              <span className="meta-item"><FiUser /> {note.uploadedBy.name}</span>
            )}
            {note.createdAt && (
              <span className="meta-item"><FiCalendar /> {formatDate(note.createdAt)}</span>
            )}
          </div>

          <div className="note-actions">
            <button className="btn btn-sm btn-primary" onClick={handleDownload}>
              <FiDownload /> Download
            </button>

            {canDelete && (
              <button
                className="btn btn-sm btn-ghost"
                style={{ color: 'var(--danger)' }}
                onClick={() => setShowConfirm(true)}
                disabled={deleting}
                title="Delete Note"
              >
                <FiTrash2 /> {deleting ? '...' : 'Delete'}
              </button>
            )}
          </div>
        </div>
      </div>

      <ConfirmDialog
        isOpen={showConfirm}
        title="Delete Study Material?"
        message={`Are you sure you want to delete "${note.title}"? This action cannot be undone.`}
        confirmText="Delete Note"
        onConfirm={handleConfirmDelete}
        onCancel={() => setShowConfirm(false)}
      />
    </>
  );
};

export default NoteCard;